<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4" style="max-width:545px">
        <h3>SAF-T: Extract omsetningsrapport</h3>

        <div v-if="!loading">
            <div class="mt-4">
              <span class="ingredient-title">Velg SAF-T XML fil</span>
              <input type="file" class="form-control mt-2" accept=".xml" @change="onFileSelected" ref="fileInput" />
            </div>

            <button type="button" class="bo_btn mt-3" :class="zReports.length == 0 ? 'mb-5' : 'mb-0'" @click="uploadSaftFile" :disabled="!selectedFile"> Vis omsetningsrapport </button>

            <div v-if="errorMessage" class="alert alert-danger mt-3">
              {{ errorMessage }}
            </div>

            <div v-if="zReports.length == 0 && resultFetched && !errorMessage" class="xz-report mb-5">
              <p class="no-report-found">Ingen omsetning funnet i SAF-T filen.</p>
            </div>

            <ShowTurnoverReport v-if="zReports.length > 0"
                                :zReports="zReports"
                                :vat="vat"
                                :company="{}"
                                :location="saftLocation"
                                :terminal="saftTerminal"
                                :fromDate="fromDate"
                                :toDate="toDate"
                                :saftSource="true" />
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import ShowTurnoverReport from "@/components/report/turnover/ShowTurnoverReport";
  import ReportService from "@/services/report/ReportService";

  export default {
    components: {LoadingSpinner, ShowTurnoverReport},
    data() {
      return {
        loading: false,
        selectedFile: null,
        zReports: [],
        vat: { takeOut: 15, dineIn: 25 },
        fromDate: '',
        toDate: '',
        saftLocation: { name: 'SAF-T Import', vatNumber: '' },
        saftTerminal: { terminalId: 'ALL' },
        resultFetched: false,
        errorMessage: ''
      };
    },
    methods: {
      onFileSelected(event) {
        this.selectedFile = event.target.files[0];
        this.zReports = [];
        this.resultFetched = false;
        this.errorMessage = '';
      },
      uploadSaftFile() {
        if (!this.selectedFile) return;

        this.loading = true;
        this.errorMessage = '';
        this.zReports = [];

        ReportService.uploadSaftFile(this.selectedFile).then(
            (response) => {
              if (response.data && response.data.length > 0) {
                this.zReports = response.data;
                this.extractMetadataFromFile();
              } else {
                this.zReports = [];
              }

              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
              this.errorMessage = 'Kunne ikke lese SAF-T filen. Sjekk at filen er en gyldig SAF-T Kassasystem XML fil.';
              this.loading = false;
              this.resultFetched = true;
            }
        );
      },
      extractMetadataFromFile() {
        // Read the XML file locally to extract header dates and VAT rates
        if (this.selectedFile) {
          let reader = new FileReader();
          reader.onload = (e) => {
            try {
              let parser = new DOMParser();
              let doc = parser.parseFromString(e.target.result, 'text/xml');
              let startDate = doc.getElementsByTagName('startDate');
              let endDate = doc.getElementsByTagName('endDate');
              if (startDate.length > 0) {
                this.fromDate = startDate[0].textContent;
              }
              if (endDate.length > 0) {
                this.toDate = endDate[0].textContent;
              }

              // Extract company/location name
              let companyName = doc.getElementsByTagName('companyName');
              if (companyName.length > 0) {
                this.saftLocation.name = companyName[0].textContent;
              }
              let companyIdent = doc.getElementsByTagName('companyIdent');
              if (companyIdent.length > 0) {
                this.saftLocation.vatNumber = companyIdent[0].textContent;
              }

              // Extract VAT rates from vatCodeDetails (vatCode 1 = takeOut, vatCode 2 = dineIn)
              let vatCodeDetails = doc.getElementsByTagName('vatCodeDetail');
              for (let i = 0; i < vatCodeDetails.length; i++) {
                let detail = vatCodeDetails[i];
                let vatCode = detail.getElementsByTagName('vatCode')[0];
                let vatDesc = detail.getElementsByTagName('vatDesc')[0];
                if (vatCode && vatDesc) {
                  let code = vatCode.textContent.trim();
                  let desc = vatDesc.textContent.trim();
                  let rateMatch = desc.match(/[\d.]+/);
                  if (rateMatch) {
                    let rate = parseFloat(rateMatch[0]);
                    if (code === '1') {
                      this.vat.takeOut = rate;
                    } else if (code === '2') {
                      this.vat.dineIn = rate;
                    }
                  }
                }
              }
            } catch (err) {
              console.log('Could not extract dates from file:', err);
            }
          };
          reader.readAsText(this.selectedFile);
        }
      }
    }
  };
</script>
